import { Col } from "reactstrap";
import {
  Accordion,
  AccordionItem,
  Icon,
  NavLink,
  Typography,
} from "cfa-react-components";
import { ReportSearch } from "@cfa-icons/system";

import { NavLink as ReactRouterNavLink } from "react-router-dom";
import IRiskInfoTable from "../../interfaces/IRiskInfoTable";
import { getUserPermissions } from "../../utils/LocalStorage";

const RiskAnalysisAccordionDropdown: React.FC<IRiskInfoTable> = ({
  compSwitch,
}: IRiskInfoTable): JSX.Element => {
  const passComp = (comp: string) => {
    compSwitch(comp);
  };
  const treasuryPermissions = getUserPermissions();

  //change navlink to typography or maybe to link as button
  return (
    <>
      <Col>
        <Typography gutterBottom variant="h3">
          Reporting
        </Typography>

        <Accordion
          iconPosition="end"
          variant="default"
          defaultActiveItemKey="0"
        >
          <AccordionItem header="Risk Analysis" itemKey="0">
            {(() => {
              if (
                treasuryPermissions != null &&
                (treasuryPermissions.hasOwnProperty("SHERLOCK_LOGIN") ||
                  treasuryPermissions.hasOwnProperty("SUPERUSER"))
              ) {
                return (
                  <NavLink
                    aria-label="Navigate to reporting"
                    variant="sidenavigation-link"
                    icon={<Icon icon={ReportSearch} size={"md"} />}
                    onClick={() => passComp("info")}
                    as={ReactRouterNavLink}
                    to={"riskInformation"}
                  >
                    <Typography style={{ wordBreak: "break-word" }}>
                      Project Sherlock
                    </Typography>
                  </NavLink>
                );
              }
              return null;
            })()}
            <NavLink
              aria-label="Navigate to reporting"
              variant="sidenavigation-link"
              icon={<Icon icon={ReportSearch} size={"md"} />}
              onClick={() => passComp("deposit")}
              as={ReactRouterNavLink}
              to={"depositoryAssignments"}
            >
              <Typography style={{ wordBreak: "break-word" }}>
                {" "}
                Excessive Activity Report{" "}
              </Typography>
            </NavLink>
          </AccordionItem>
        </Accordion>
      </Col>
    </>
  );
};

export default RiskAnalysisAccordionDropdown;
